import Robot from './index';
import Projects from './Projects';
import Change from './Change';
import Info from './Info'
import RobotPairConfig from './RobotPairConfig'
// import Instance from './Instance'

export default {
  path: '/home/robot',
  component: Robot,
  redirect: '/home/robot/info',
  children: [
    { path: '/home/robot/projects', component: Projects },
    { path: '/home/robot/change', component: Change },
    { path: '/home/robot/info', component: Info },
    { path: '/home/robot/robotPairConfig', component: RobotPairConfig },
    // { path: '/home/robot/instance', component: Instance },
  ]
};
